import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "../lib/cn";
import { focusRing, hoverTransition } from "../lib/styles";
import { Icon } from "./Icon";

export type CheckboxProps = Omit<
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
  "className"
> & { className?: string };

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(function Checkbox(
  { className, ...rest },
  ref,
) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-xs border border-control bg-default",
        // The control itself is 16px; the surrounding label/cell provides the
        // >=24px target (doc 40 §8), which the DataTable header/cell enforces.
        "data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-on-primary",
        "data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-on-primary",
        "disabled:cursor-not-allowed disabled:border-default disabled:bg-subtle",
        focusRing,
        hoverTransition,
        className,
      )}
      {...rest}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        {rest.checked === "indeterminate" ? (
          <span aria-hidden="true" className="block h-px w-2 bg-current" />
        ) : (
          <Icon name="check" size={4} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
